// ==========================================================
// TYPES DE FACTURATION
// ==========================================================

export const OPTION_BILLING_TYPES = {
  fixed: "Forfait",
  daily: "Journalier",
};
